/**
 * The names under which create_request_draft and update_request take the customer's
 * Biotopausgleich: how much, and up to what price per unit. The request itself states neither any
 * more (its needs are its lines, ARCH-039 D19), but the assistant, its evals and the conversion
 * value in useSalesChat speak these names, so they stay: both tools bind them to the customer's
 * Biotopausgleich line. This is the one module that names them
 * (lib/requests/request-retired-columns.guard.test.ts allows it, and only it).
 *
 * Client-safe: useSalesChat reads a finished tool call's input by them.
 */

/** The Biotopausgleich's amount, in its unit: Ökopunkte or Hektar. */
export const QUANTITY_ARG = "quantity_needed";

/** The Biotopausgleich's ceiling per unit of that amount: per Ökopunkt or per Hektar. */
export const MAX_PRICE_ARG = "max_price_per_point";
